import _ from 'lodash'
import { getEmptyAppointment, getInitialState } from './initial-state'

const mutations = {
    mutateLoadingGeneral(state, payload) {
        state.loading.general = payload
    },
    mutateLoadingServices(state, payload) {
        state.loading.publicServices = payload
    },
    mutateLoadingLocations(state, payload) {
        state.loading.locations = payload
    },
    mutateLoadingEmployees(state, payload) {
        state.loading.employees = payload
    },
    mutateLoadingSchedule(state, payload) {
        state.loading.schedule = payload
    },
    mutateLoadingTimeSlots(state, payload) {
        state.loading.timeSlots = payload
    },
    mutateLoadingChildren(state, payload) {
        state.loading.children = payload
    },
    mutateLoadingPets(state, payload) {
        state.loading.pets = payload
    },
    mutateCurrentIndex(state, payload) {
        state.currentIndex = payload
    },
    mutateCurrentStep(state, payload) {
        state.currentStep = payload
    },
    mutateIssueId(state, payload) {
        state.issueId = payload
    },
    mutateMainProblem(state, payload) {
        state.mainProblem = payload
    },
    addAnotherAppointment(state) {
        state.appointments.unshift(getEmptyAppointment())
        state.currentIndex = 0
    },
    setCurrentAppointment(state, payload) {
        if (payload > -1 && payload < state.appointments.length) {
            state.currentIndex = payload
        }
    },
    removeAppointment(state, payload) {
        if (payload > -1 && payload < state.appointments.length) {
            state.appointments.splice(payload, 1)
            if (state.appointments.length) {
                state.currentIndex = 0
            }
        }
    },
    clearAppointment(state) {
        const {
            loading,
            serviceCategories,
            citiesByCategory,
            publicServices,
            citiesByService,
            locations,
            employees,
            employeeSchedule,
            bookedTimes,
            customerChildren,
            customerPets,
            currentIndex,
            appointments,
            currentStep
        } = getInitialState()
        state.loading = loading
        state.serviceCategories = serviceCategories
        state.citiesByCategory = citiesByCategory
        state.publicServices = publicServices
        state.citiesByService = citiesByService
        state.locations = locations
        state.employees = employees
        state.employeeSchedule = employeeSchedule
        state.bookedTimes = bookedTimes
        state.customerChildren = customerChildren
        state.customerPets = customerPets
        state.currentIndex = currentIndex
        state.appointments = appointments
        state.currentStep = currentStep
    },

    // Step 1
    mutateSelectedCategory(state, payload) {
        state.appointments[state.currentIndex].selectedCategory = payload
    },
    mutateServiceKeyword(state, payload) {
        state.appointments[state.currentIndex].serviceKeyword = payload
    },
    mutateSelectedPublicServiceDescriptionState(state, payload) {
        state.appointments[state.currentIndex].selectedServiceState = payload
    },
    mutateSelectedPublicServiceDescriptionCities(state, payload) {
        state.appointments[state.currentIndex].selectedServiceCities = payload
    },
    mutateServiceCategories(state, payload) {
        state.serviceCategories = payload
    },
    mutateCitiesByCategory(state, payload) {
        state.citiesByCategory = _.groupBy(payload, 'state_name')
    },
    mutatePublicServices(state, payload) {
        state.publicServices = payload
    },

    // Step 2
    mutateCitiesByService(state, payload) {
        state.citiesByService = _.groupBy(payload, 'state_name')
    },
    mutateSelectedPublicServiceDescription(state, payload) {
        state.appointments[state.currentIndex].publicService = payload
    },
    mutateLocationKeyword(state, payload) {
        state.appointments[state.currentIndex].locationKeyword = payload
    },
    mutateSelectedLocationState(state, payload) {
        state.appointments[state.currentIndex].selectedLocationState = payload
    },
    mutateSelectedLocationCities(state, payload) {
        state.appointments[state.currentIndex].selectedLocationCities = payload
    },
    mutateAvailableDates(state, payload) {
        state.appointments[state.currentIndex].availableDates = payload
    },
    mutateBookingDate(state, payload) {
        state.appointments[state.currentIndex].bookingDate = payload
        state.appointments[state.currentIndex].selectedTime = undefined
        state.appointments[state.currentIndex].selectedTimeSlotIndex = undefined
        state.appointments[state.currentIndex].schedule = undefined
    },
    mutateSelectedTimeSlotIndex(state, payload) {
        state.appointments[state.currentIndex].selectedTimeSlotIndex = payload
    },
    mutateSelectedTime(state, payload) {
        state.appointments[state.currentIndex].selectedTime = payload
    },
    mutateLocations(state, payload) {
        state.locations = payload
    },
    mutateSelectedLocation(state, payload) {
        state.appointments[state.currentIndex].location = payload
        if (payload) {
            state.appointments[state.currentIndex].service = {
                id: payload.service_id,
                price: payload.service_price,
                duration: payload.service_duration
            }
        } else {
            state.appointments[state.currentIndex].service = undefined
        }
    },
    mutateEmployees(state, payload) {
        state.employees = payload
    },
    mutateSelectedEmployee(state, payload) {
        state.appointments[state.currentIndex].employee = payload
    },
    mutateBookedTimes(state, payload) {
        state.bookedTimes = payload
    },
    mutateEmployeeSchedule(state, payload) {
        state.employeeSchedule = payload
    },
    mutateSelectedSchedule(state, payload) {
        state.appointments[state.currentIndex].schedule = payload
    },

    // Step 3
    mutateSelectedCustomerType(state, payload) {
        state.appointments[state.currentIndex].customerType = payload
    },
    mutateCustomerChildren(state, payload) {
        state.customerChildren = payload
    },
    mutateCustomerPets(state, payload) {
        state.customerPets = payload
    },
    mutateSelectedCustomerId(state, payload) {
        state.appointments[state.currentIndex].customer.id = payload
    },
    mutateSelectedCustomerName(state, payload) {
        state.appointments[state.currentIndex].customer.name = payload
    },
    mutateSelectedChildId(state, payload) {
        state.appointments[state.currentIndex].customer.childId = payload
    },
    mutateSelectedPetId(state, payload) {
        state.appointments[state.currentIndex].customer.petId = payload
    }
}

export default mutations
